export const home = {
  heroTitle: "Digital Archive of German Websites",
  heroDescription:
    "Search, discover and categorize German websites. A collaborative platform for libraries for the systematic collection and archiving of digital content.",
  search: "Search",
  aiSearching: "Searching...",
  aiSearchToggleLabel: "AI Search",
  aiSearchStatusOn: "ON",
  aiSearchStatusOff: "OFF",
  aiSearchStatusForcedOff: "FORCED OFF (admin)",
  aiSearchStatusHintOn:
    "Natural-language parsing is active for category, region, and text filters.",
  aiSearchStatusHintOff:
    "Plain text search mode. Turn AI search on to resolve categories and regions automatically.",
  aiSearchStatusHintForcedOff:
    "AI search is disabled by system configuration. Your preference is kept for later.",
  aiSearchTurnOn: "Turn on AI search",
  aiSearchTurnOff: "Turn off AI search",
  aiSearchToggleHint:
    "Natural-language queries are automatically mapped to category, region, and text filters (including multi-region, macro-region, and postal-code intents).",
  aiSearchDisabled:
    "AI search is currently disabled by system configuration.",
  aiSuggestionDistrictPairDe: "Museum in Lower Bavaria or Upper Bavaria",
  aiSuggestionVicinityDe: "family support center near Lower Bavaria",
  aiSuggestionMacroRegionDe: "pediatrician in Southern Bavaria",
  aiSuggestionDescriptive:
    "counselling center around Munich with online support",
  aiSuggestionBrandDe: "4benefits fitness studio in Bavaria",
  aiSuggestionTyposDe: "fitnesstudio near munich",
  aiSuggestionDistrictPairEn: "museum in Lower Bavaria or Upper Bavaria",
  aiSuggestionVicinityEn:
    "family support center in the vicinity of Lower Bavaria",
  aiSuggestionMacroRegionEn: "pediatrician in Southern Bavaria",
  aiSuggestionBrandEn: "4benefits fitness studio in Bavaria",
  aiSuggestionMixedDeEn: "a school around Munich with digital learning",
  browseCategories: "Browse by Categories",
  viewStatistics: "View Statistics",
  statsWebsites: "Websites",
  statsCategories: "Categories",
  statsUsers: "Registered Users",
  featuresTitle: "Features",
  featuresDescription:
    "WebKurator.de offers comprehensive tools for managing and categorizing German websites for archival purposes.",
  featureAdvancedSearch: "Advanced Search",
  featureAdvancedSearchDesc:
    "Search thousands of archived websites by title, content or category with powerful filters.",
  featureCategorization: "Categorization",
  featureCategorizationDesc:
    "Hierarchical categorization by topics and regions with automated suggestions through machine learning.",
  featureCollaboration: "Collaboration",
  featureCollaborationDesc:
    "Collaborative platform for national, state and regional libraries for efficient cooperation.",
  featureLongTermArchiving: "Long-term Archiving",
  featureLongTermArchivingDesc:
    "Secure archiving of digital content as part of the University of Passau project.",
  featureStatistics: "Statistics",
  featureStatisticsDesc:
    "Detailed insights into the database with automatically generated statistics and reports.",
  featurePublicAccess: "Public Access",
  featurePublicAccessDesc:
    "Barrier-free and publicly accessible for research, education and general use.",
  ctaTitle: "Become Part of the Project",
  ctaDescription:
    "Register to add, categorize and contribute to the quality of the digital archive.",
  ctaRegister: "Register Now",
  ctaSuggest: "Suggest Website",
  ctaLogin: "Login",
};

export const categories = {
  title: "Categories",
  subtitle: "Browse websites by category",
  websites: "Websites",
  subcategories: "Subcategories",
  browse: "Browse Categories",
  browseDescription:
    "Click a category to filter. Subcategories may be available.",
  thematic: "Thematic",
  thematicFilterHeading: "Thematic Filter",
  regional: "Regional",
  regionalFilterHeading: "Regional Filter",
  back: "Back",
  inThisCategory: "Websites in this category",
  showSubcategories: "Subcategories",
  showResults: "Show Results",
  mostFrequent: "Most frequent subcategories:",
  browseCategory: "Browse Category",
  showMore: "Show Subcategories",
  germanyMap: "Germany Map",
  germanyMapDescription:
    "Click on a federal state to see websites from this region",
  interactiveMap: "Interactive Germany Map",
  interactiveMapDescription:
    "In the full version, an interactive map of German federal states would be displayed here",
  federalStates: "Federal States",
  totalWebsites: "Total websites",
  filterSort: "Filter & Sort",
  sortBy: "Sort by",
  sortRelevance: "Relevance",
  sortDateNew: "Newest first",
  sortDateOld: "Oldest first",
  sortTitleAsc: "Title A-Z",
  sortTitleDesc: "Title Z-A",
  filterRegion: "Region",
  allRegions: "All Regions",
  filterTime: "Time Period",
  allPeriods: "All Periods",
  lastWeek: "Last Week",
  lastMonth: "Last Month",
  lastYear: "Last Year",
  searchInCategory: "Search in category",
  openCategory: "Open Category",
  germanyMapFilterTitle: "Germany Map – Filter by State",
  germanyMapFilterDescription:
    "Select a state to zoom in automatically. If the state provides administrative districts or districts, those layers become active so you can pick individual regions and instantly refine the results.",
  resetSelection: "Reset selection",
  allStatesSelected: "All states selected",
  mapResolutionLabel: "Map resolution",
  mapResolutionLow: "Low (fast)",
  mapResolutionLowDescription:
    "Simplified geometries for quick overviews on any device.",
  mapResolutionMedium: "Medium (balanced)",
  mapResolutionMediumDescription:
    "Detailed enough for most workflows with moderate file size.",
  mapResolutionHigh: "High",
  mapResolutionHighDescription:
    "Adds extra detail while keeping interactions responsive.",
  mapResolutionVeryHigh: "Very high (max detail)",
  mapResolutionVeryHighDescription:
    "Full-resolution boundaries for the most precise selections.",
  mapResolutionWarning:
    "The very high resolution may slow down older browsers and devices. Use it only when you need maximum detail.",
  panModeLabel: "Pan map",
  panModeActive: "Pan mode active",
  panModeHint: "Hold Shift, then drag or scroll to move or zoom",
  panModeShiftKey: "Shift",
  zoomInLabel: "Zoom in",
  zoomOutLabel: "Zoom out",
  mapLayerLabel: "Selectable layer",
  mapLayerCountry: "Germany",
  mapLayerCountryShort: "Germany",
  mapLayerCountryDescription:
    "Outline of Germany for orientation. This layer cannot be selected.",
  mapLayerStates: "Federal States",
  mapLayerStatesShort: "Federal States",
  mapLayerStatesDescription:
    "Select Bundesländer such as Bayern, Hessen or Berlin.",
  mapLayerAdministrative: "Administrative Districts",
  mapLayerAdministrativeShort: "Administrative Districts",
  mapLayerAdministrativeDescription:
    "Select Regierungsbezirke such as Niederbayern or Oberfranken.",
  mapLayerDistricts: "Districts",
  mapLayerDistrictsShort: "Districts",
  mapLayerDistrictsDescription:
    "Select counties (Landkreise) such as Freyung-Grafenau.",
  mapLayerPostalCodes: "Postal Codes",
  mapLayerPostalCodesShort: "Postal Codes",
  mapLayerPostalCodesDescription:
    "Select postal-code areas (PLZ) such as 94032.",
  mapPrecisionToggleLabel: "Precision mode",
  mapPrecisionToggleDescription:
    "Open the fullscreen map to pick very small districts with higher accuracy.",
  mapPrecisionActive: "Exit precision mode",
  mapPrecisionDefault: "Open precision mode",
  mapPrecisionOverlayTitle: "Precision selection",
  mapPrecisionOverlaySubtitle:
    "Fullscreen Germany map for detailed administrative selections.",
  mapPrecisionOverlayHint:
    "Use the close button or press Esc to return to the standard map.",
  selectionSummaryTitle: "Selected regions",
  mapDetailSectionTitle: "Drill deeper",
  mapDetailSectionDescription:
    "Select one of your federal states to expose administrative districts or districts.",
  mapDetailStateLabel: "Focused federal state",
  mapDetailStatePlaceholder: "Pick a selected federal state",
  mapDetailLayerLabel: "Detail level",
  mapDetailLayerHint:
    "Choose administrative districts for coarse detail or districts for maximum granularity.",
  mapDetailLayerDisabled:
    "Select at least one federal state to enable detailed layers.",
  mapDetailLayerClear: "Reset detail view",
  resultsPerPage: "Results per page",
  paginationPrevious: "Previous",
  activeFiltersTitle: "Filtering by:",
  clearAllFilters: "Clear all filters",
  activeQueryLabel: "Query",
  activeCategoryLabel: "Category",
  removeFilter: "Remove filter",
  searchTermPlaceholder: "Filter results...",
  jumpToPageLabel: "Jump to page",
  jumpToPagePlaceholder: "#",
  jumpToPageGo: "Go to Page",
  regionSearchPlaceholder: "Type a state, district or postal code...",
  regionSearchNoResults: "No matching regions found.",
  thematicSearchPlaceholder: "Type a category...",
  thematicSearchNoResults: "No matching categories found.",
  scrollUpHintTitle: "Jump to thematic & regional filters (up)",
  scrollUpHintDescription:
    "Use this shortcut to jump back to the category and regional filters further up the page.",
  scrollDownHintTitle: "Jump to text search (down)",
  scrollDownHintDescription:
    "Tap here to scroll down to the keyword filter card and refine the list below.",
  searchResultsTitle: "Search Results",
  searchResultsFound: "Found",
  resultsSummary: "Showing {{start}}-{{end}} of {{count}} results",
  lastSubcategorySelectedTitle: "Final subcategory level reached",
  lastSubcategorySelectedDescription:
    "You are currently scoped to the final subcategory: {{category}}.",
};

export const statistics = {
  title: "Statistics",
  subtitle: "Detailed insights into the database and usage of WebKurator.de",
  overviewTab: "Overview",
  totalWebsites: "Number of Websites",
  totalCategories: "Categories",
  totalCategoriesDetail: "total categories",
  activeUsers: "Registered Users",
  registeredUsersDetail: "active user accounts",
  thisMonth: "This Month",
  newWebsites: "New Websites",
  topCategories: "Top Categories",
  recentActivity: "Recent Activity",
  mainCategories: "Main Categories",
  avgPerWebsite: "Avg per Website",
  categoriesPerWebsite: "Categories",
  last30Days: "in the last 30 days",
  growth: "Growth",
  categoriesTab: "Categories",
  regions: "Regions",
  engagementTab: "Engagement",
  overviewPanelTitle: "Platform Snapshot",
  overviewPanelDesc:
    "Fast, counter-based headline metrics. Open tabs for growth, category depth, regional distribution and engagement.",
  monthlyTrends: "Monthly Trends",
  monthlyTrendsDesc: "New websites and user registrations per month.",
  websiteGrowth: "Website Growth",
  websiteGrowthDescription: "Number of websites added per month",
  userGrowth: "User Growth",
  userGrowthDescription: "Number of new user registrations per month",
  newUsers: "New Users",
  categoryDistribution: "Distribution by Categories",
  categoryDistributionDesc: "Breakdown of websites across all main categories.",
  categoryDistributionDescription: "Number of websites per main category",
  categoryDepthCoverage: "Category Depth Coverage",
  categoryDepthCoverageDesc:
    "Distribution of active websites by their deepest assigned category level.",
  depthLabel: "Depth {{depth}}",
  depthMeaning0: "Only main category",
  depthMeaning1: "Main category + 1 subcategory",
  depthMeaning2: "Main category + 2 subcategories",
  depthMeaning3: "Main category + 3 subcategories",
  depthMeaning4: "Main category + 4 subcategories (maximum depth)",
  depthMeaningFallback: "Depth {{depth}}",
  avgDepthShort: "Depth",
  depthLegendTitle: "Depth Legend (0 to 4)",
  depthLegendDesc:
    "Depth indicates how deep the deepest assigned category path goes for a website.",
  depthLegend0: "Depth 0: root category only (very broad topic assignment).",
  depthLegend1: "Depth 1: one subcategory below the root.",
  depthLegend2: "Depth 2: two subcategory levels, more specific topic fit.",
  depthLegend3: "Depth 3: deep specialization in the category tree.",
  depthLegend4: "Depth 4: maximum supported depth (most specific path).",
  topCategoriesTitle: "Top Categories",
  topCategoriesDescription: "Detailed breakdown by categories",
  topFederalStates: "Top Federal States",
  federalStatesDescription: "Websites by federal state",
  regionalDistribution: "Regional Distribution",
  regionalBreakdown: "Regional Breakdown",
  regionalBreakdownDesc:
    "Compare how websites are distributed across federal states and regions.",
  layerLabel: "Layer",
  selectedLayer: "Selected layer",
  totalInSelectedLayer: "Websites in selected layer",
  topOnlyLayerHint: "Showing top {{limit}} {{layer}} by website count.",
  shownVsTotal:
    "Top list currently covers {{shown}} of {{total}} websites in this layer.",
  layer: {
    state: "States",
    administrativeDistrict: "Administrative districts",
    district: "Districts",
    postalCode: "Postal codes",
  },
  regionalDistributionDescription: "All federal states at a glance",
  currentWeek: "Current Week",
  activeUsersTitle: "Active Users",
  averages: "Averages",
  newWebsitesCount: "New Websites",
  newUsersCount: "New Users",
  categorizations: "Categorizations",
  today: "Today",
  thisWeek: "This Week",
  thisMonthTitle: "This Month",
  websitesPerDay: "Websites / Day",
  categoriesPerWebsiteAvg: "Cat. / Website",
  editsPerDay: "Edits / Day",
  dailyPageviewsTitle: "Total pageviews per day (last 30 days)",
  dailyPageviewsDesc: "Daily aggregated pageviews.",
  dailyPageviewsFailed: "Failed to load daily pageviews.",
  pageviewsLast7Days: "Pageviews (7 days)",
  pageviewsLast30Days: "Pageviews (30 days)",
  avgDailyPageviewsLast7Days: "Average daily pageviews (7 days)",
  peakPageviewsDay: "Peak pageview day",
  peakOnDate: "On {{date}}",
  rangeLabel: "Range: {{from}} -> {{to}}",
  pageviewsLabel: "Pageviews",
  websitesLabel: "Websites",
  categoryLabel: "Category",
  dateLabel: "Date",
  failedToLoad: "Failed to load statistics.",
  monthLabel: "Month",
  avgCategories: "Average categories",
  perWebsite: "per website",
  latestWebsiteAdded: "Latest website added",
  latestWebsiteAddedDetail: "Most recent active website entry",
  latestUserRegistered: "Latest user registration",
  latestUserRegisteredDetail: "Most recent registered account",
  topCategoryNow: "Top category right now",
  topCategoryShareDetail: "{{share}}% of all websites ({{count}} websites)",
  websitesLast7Days: "New websites (7 days)",
  websitesLast30DaysLabel: "New websites (30 days)",
  usersLast7Days: "New users (7 days)",
  usersLast30Days: "New users (30 days)",
  previous7Days: "Previous 7 days",
  categoryTop10: "Top 10 Main Categories (Share)",
  categoryTop10Desc:
    "Share of the top 10 main categories relative to all main categories.",
  others: "Others",
  noData: "No data available.",
};
export const websiteDetails = {
  title: "Website Details",
  openWebsite: "Open Website",
  loading: "Loading website details...",
  failed: "Failed to load website details.",
  categoryPath: "Category Path",
  regionPath: "Region Path",
  metadata: "Details",
  regionMap: "Region map",
  regionMapUnavailable: "Region map unavailable",
  pageviews: "Pageviews",
  similarWebsites: "Similar websites",
  similarWebsitesHint: "Related entries from the current recommendation source.",
  noSimilar: "No similar websites found.",
  similarFailed: "Failed to load similar websites.",
  relatedContent: "Related content",
  relatedContentAdminHint: "Switch between the public related list and admin research tools.",
  similarTab: "Similar",
  researchComparisonTab: "Research",
  researchComparisonTitle: "Research comparison",
  researchComparisonSubtitle:
    "Inspect ranking methods and the public recommendation preview.",
  researchComparisonUnavailable: "Research comparison is unavailable for this website.",
  exportJson: "Export JSON",
  methodRankings: "Method rankings",
  publicPreview: "Public preview",
  comparisonTable: "Comparison table",
  dataset: "Dataset",
  embeddingModel: "Embedding model",
  textFields: "Text fields",
  hybrid: "Hybrid",
  notConfigured: "not configured",
  noResearchItems: "No method ranking data is available.",
  noPublicPreview: "No public preview items are available.",
  websiteColumn: "Website",
  bestRank: "Best",
  rankSpread: "Spread",
  hostname: "Hostname",
  url: "Website",
  status: "Status",
  address: "Address",
  zipCode: "Postal code",
  region: "Region",
  regionState: "Federal state",
  regionLayer: "Region level",
  coordinates: "Coordinates",
  addedAt: "Added",
  addedBy: "Added by",
  openDetails: "Open details",
  showSimilar: "Show related",
  hideSimilar: "Hide related",
};


